module.exports = __webpack_public_path__ + "img/gest.164f61d2.jpg";